module.exports = __webpack_public_path__ + "static/051a1254bc519dd8a25f025b4fec32fb0f65d248275dfbece18d8593c028f69f-5d5228fb8d0b750b1a3c5fa79600dc1c.jpeg";